import React from 'react';
import { FellowDTO } from '../../services/apiClient';
import { User } from 'lucide-react';

export interface FellowOption {
  value: string | undefined;
  label: React.ReactNode;
  searchText: string;
}

export function buildFellowOptions(fellows: FellowDTO[]): FellowOption[] {
  const sortedFellows = [...fellows].sort((a, b) => {
    const aKey = a.companyName ?? a.name ?? '';
    const bKey = b.companyName ?? b.name ?? '';
    const companyCompare = aKey.localeCompare(bKey);
    if (companyCompare !== 0) return companyCompare;
    return (a.name ?? '').localeCompare(b.name ?? '');
  });

  return sortedFellows.map((fellow) => {
    return {
      value: fellow.id,
      searchText: `${fellow.name ?? ''} ${fellow.companyName ?? ''}`,
      label: (
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0 w-7 h-7 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center">
            <User className="w-4 h-4 text-gray-400" />
          </div>
          <div className="flex flex-col min-w-0">
            {fellow.companyName && (
              <span className="text-sm text-slate-700 dark:text-slate-200 truncate">{fellow.companyName}</span>
            )}
            {fellow.name && (
              <span
                className={`${fellow.companyName ? 'text-xs' : 'text-sm'} text-slate-700 dark:text-slate-200 truncate`}
              >
                {fellow.name}
              </span>
            )}
          </div>
        </div>
      ),
    };
  });
}
